export const getResizeControlStyles = (zoom: number) => {
  return {
    '& .react-flow__resize-control.scale-control.handle': {
      scale: 1 / zoom,
    },
  };
};
